export default __webpack_public_path__ + "static/media/CSV.fbcc920d.svg";